import React from 'react'
import { Button, Row, Image, Separator, useContainerWidth, Paragraph, H4, Grid } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import image from './images/oops.svg'

export default function ErrorBoundaryFallback() {
  const containerCss = css`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
  `
  const [t] = useTranslation()
  const defaultTitle = t('error-overlay-boundary.heading', 'Something unexpected happened.')
  const defaultMessage = t('error-overlay-boundary.content', 'Try again or refresh the page if the problem persists.')
  const isNarrow = useContainerWidth()({ default: true, sm: false })
  return (
    <div css={containerCss}>
      <div>
        <Separator size={isNarrow ? 'xxl' : 'sm'} />
        <Row alignX="center">
          <Image maxHeight={315} maxWidth="100%" src={image} alt="" />
        </Row>
        <Separator size="md" />
        <Row alignX="center">
          <H4 centered>{defaultTitle}</H4>
        </Row>
        <Separator size="xxs" />
        <Row alignX="center">
          <Paragraph centered>{defaultMessage}</Paragraph>
        </Row>
        <Separator size="md" />
        <Grid>
          <Row alignX="center">
            <Button data-testid="go-back-button" onClick={() => window.history.back()}>
              {t('tasks-done-overlay.go-back.button', 'Go Back')}
            </Button>
            <Button data-testid="refresh-button" onClick={() => window.location.reload()} emphasis="high">
              {t('error-overlay.submit', 'Refresh')}
            </Button>
          </Row>
          <Separator size="xxs" />
        </Grid>
        {isNarrow && <Separator size="sm" />}
      </div>
    </div>
  )
}
